<div class="month-select-filter-label">{{ 'label.filter' | translate}}</div>
<mat-selection-list #billingMonthSelect [multiple]="false">
  <mat-list-option (click)="selectedBillingMonth(null)">
    {{ 'label.all' | translate}}
  </mat-list-option>
  <div *ngFor="let billingMonthSelect of billingMonthSelects">
    <mat-list-option *ngFor="let billingMonth of billingMonthSelect.month" [value]="billingMonth.id"
      (click)="selectedBillingMonth(billingMonth)">
      {{billingMonthSelect.year}} - {{ ('label.month-' + billingMonth.month) | translate}}
    </mat-list-option>
  </div>
</mat-selection-list>